import { http, HttpResponse } from 'msw';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router';
import { worker } from '../test/mocks/lib/serviceMock';
import { main } from './configuration';
import { config } from './configuration/config';
import './configuration/setup/datadog';
import { handleLoginRedirect } from './configuration/setup/redirect';
import { store } from './configuration/setup/store';
import { RouteWidgetProvider } from './context/RouteWidgetContext';
import { router } from './routes/Router';

if (import.meta.env.VITE_E2E === 'true') {
    (globalThis as unknown as Record<string, unknown>).__store__ = store;
    // Expose the MSW worker and helpers so E2E tests can override request handlers
    // at runtime (e.g. to simulate offline/error responses for send-to-vehicle),
    // since MSW intercepts requests before Playwright's page.route can.
    (globalThis as unknown as Record<string, unknown>).__mswWorker__ = worker;
    (globalThis as unknown as Record<string, unknown>).__msw__ = { http, HttpResponse };
}

const renderApplication = () => {
    createRoot(document.getElementById('root') as HTMLElement).render(
        <Provider store={store}>
            <RouteWidgetProvider>
                <RouterProvider router={router} />
            </RouteWidgetProvider>
        </Provider>
    );
};

if (window.location.href.startsWith(config.login.redirectUri as string)) {
    handleLoginRedirect();
} else if (config.enableMockServer) {
    worker
        .start({
            onUnhandledRequest: 'bypass',
        })
        .then(() => main(renderApplication));
} else {
    main(renderApplication);
}
